import { render, staticRenderFns } from "./LayoutsFormDialog.vue?vue&type=template&id=76557d7b&scoped=true"
import script from "./LayoutsFormDialog.vue?vue&type=script&lang=js"
export * from "./LayoutsFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76557d7b",
  null
  
)

export default component.exports